import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconConfluence({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M.58 11.736c2.9-4.717 6.69-4.857 11.15-2.69a399.98 399.98 0 0 0 3.31 1.573.51.51 0 0 1 .255.667l-1.576 3.564a.51.51 0 0 1-.685.255l-3.281-1.56c-2.378-1.136-3.697-1.401-5.008.763-.186.308-.356.595-.489.817a.51.51 0 0 1-.705.173l-3.31-2.037a.51.51 0 0 1-.17-.692c.158-.25.344-.563.51-.833zM12.05.013a.51.51 0 0 1 .399.074l3.31 2.037a.51.51 0 0 1 .17.692c-.158.25-.344.563-.51.832C12.52 8.361 8.73 8.506 4.26 6.342l-.47-.226-.473-.226A471.52 471.52 0 0 0 .95 4.769a.51.51 0 0 1-.254-.667L2.27.537a.51.51 0 0 1 .684-.254l3.272 1.553c2.378 1.135 3.696 1.4 5.008-.764l.488-.817a.509.509 0 0 1 .326-.242z"/>
        </svg>
    );
}

export default IconConfluence;
